import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { ALL_UI_IDS, FOCUSABLE_SELECTORS } from '../constants';
var DISABLED = 'tabindex-disabled';
var overlayCaller = [];
export var disableTabindexByElement = function disableTabindexByElement(el) {
  if (el) {
    var focusable = el.querySelectorAll(FOCUSABLE_SELECTORS);
    Array.from(focusable).forEach(function (el) {
      el.setAttribute('tabindex', '-1');
      el.classList.add(DISABLED);
    });
  }
};
export var restoreDisabledTabindexByElement = function restoreDisabledTabindexByElement(el) {
  if (el) {
    var focusable = el.querySelectorAll(".".concat(DISABLED));
    Array.from(focusable).forEach(function (el) {
      el.classList.remove(DISABLED);
      el.setAttribute('tabindex', '0');
    });
  }
};
export var disableAllUITabIndex = function disableAllUITabIndex(caller) {
  var disabled = false;
  ALL_UI_IDS.forEach(function (id) {
    var el = document.getElementById(id);

    if (el) {
      disabled = true;
      var focusable = el.querySelectorAll(FOCUSABLE_SELECTORS);
      Array.from(focusable).forEach(function (el) {
        el.classList.add(DISABLED);
        el.setAttribute('tabindex', '-1');
      });
    }
  });
  if (disabled && !overlayCaller.includes(caller)) overlayCaller = [].concat(_toConsumableArray(overlayCaller), [caller]);
};
export var restoreAllDisabledTabIndex = function restoreAllDisabledTabIndex(caller) {
  if (overlayCaller.length === 0) return;
  if (overlayCaller.includes(caller)) overlayCaller = overlayCaller.filter(function (id) {
    return id !== caller;
  });

  if (overlayCaller.length === 0) {
    var disabled = document.getElementsByClassName(DISABLED);
    Array.from(disabled).forEach(function (el) {
      el.classList.remove(DISABLED);
      el.setAttribute('tabindex', '0');
    });
  }
};